import { Button, Group, Text } from '@mantine/core';
import ModalPopupComponent from 'components/ModalPopup';
import React from 'react';
import { HiOutlinePencil, HiOutlineSave } from 'react-icons/hi';

interface ModalConfirmationProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title?: string;
  courseName?: string;
  type?: 'submit' | 'update';
}

const ModalConfirmation: React.FC<ModalConfirmationProps> = ({
  opened,
  onClose,
  onConfirm,
  isLoading,
  type = 'submit',
  title = 'Submit Data',
  courseName
}) => {
  return (
    <ModalPopupComponent title={title} size='lg' opened={opened} close={onClose}>
      <Text>
        Are you sure to {type === 'submit' ? 'submit' : 'update'} this data{' '}
        <strong>{courseName}</strong>?
      </Text>
      <Group justify='flex-end' mt={'md'}>
        <Button variant='outline' onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          loading={isLoading}
          leftSection={type === 'submit' ? <HiOutlineSave /> : <HiOutlinePencil />}
          disabled={isLoading}
          onClick={onConfirm}
        >
          {type === 'submit' ? 'Create' : 'Update'} Data
        </Button>
      </Group>
    </ModalPopupComponent>
  );
};

export default ModalConfirmation;
